import { useAvailableBanks } from "api/Client/balance";
import { useClientProduct, useCreateOrder } from "api/Client/product";
import { Spinner } from "components";
import { createAlert } from "components/Alert/Alert";
import { image_host } from "config/api_host";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { FaPlus, FaMinus, FaRegImage, FaCreditCard } from "react-icons/fa";
import { useSelector } from "react-redux";

export default function BookingNow() {
  const { laptopId } = useParams();

  const [image, setImage] = useState(null); // تم تصحيح القيمة الافتراضية إلى null
  const [quantity, setQuantity] = useState(1);
  const [amount, setAmount] = useState(0);
  const [selectedBank, setSelectedBank] = useState("");
  const { role } = useSelector((state) => state.auth);

  const { mutate: create, isPending: IsPending } = useCreateOrder();

  const {
    data: productInfo,
    isLoading: productIsLoading,
    isSuccess: productIsSuccess,
  } = useClientProduct(laptopId);

  const { data: banks } = useAvailableBanks(role == "guest" ? false : true);

  if (productIsLoading)
    return (
      <div className="h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );

  const product = {
    ...productInfo?.data?.product,
    price: productInfo?.data?.price,
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!image) return createAlert("Warning", "يرجى ادخال صورة الاشعار");

    const formData = new FormData();
    formData.append("items[0][product_id]", product.id);
    formData.append("items[0][qty]", quantity);
    formData.append("payment_receipt", image);
    formData.append("paid_amount", amount);
    formData.append("bank_id", selectedBank);

    create(formData);
  };

  return (
    <div className="max-w-6xl mx-auto p-4 md:p-8_ font-[Tajawal]" dir="rtl">
      <div className="bg-gray-100 dark:bg-white/5 border border-white dark:border-white/10 rounded-[2.5rem] shadow-2xl overflow-hidden backdrop-blur-md">
        {/* رأس الصفحة: عرض المنتج */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 p-8 border-b border-gray-200 dark:border-white/10">
          <div className="flex flex-col items-center justify-center bg-white/50 dark:bg-black/20 rounded-[2rem] p-6 border border-white dark:border-transparent">
            <img
              src={image_host + product.image}
              alt={product.name}
              className="w-full max-w-[320px] drop-shadow-2xl hover:scale-105 transition-transform duration-500"
            />
          </div>

          <div className="flex flex-col justify-center space-y-4">
            <div className="space-y-1">
              <span className="text-mainLight font-bold text-xs uppercase tracking-widest">
                {product.company_name}
              </span>
              <h1 className="text-3xl md:text-4xl font-bold text-gray-800 dark:text-white leading-tight">
                {product.name}
              </h1>
            </div>

            {/* الخصائص بشكل مبسط */}
            <div className="flex flex-wrap gap-2 py-2">
              {product.fields &&
                JSON.parse(product.fields).map((f) => (
                  <div
                    key={f.fieldId}
                    className="bg-white/80 dark:bg-white/5 border border-gray-200 dark:border-white/10 px-3 py-1.5 rounded-xl text-xs flex gap-2"
                  >
                    <span className="text-gray-400">{f.name}:</span>
                    <span className="text-gray-700 dark:text-gray-200 font-bold">
                      {f.value}
                    </span>
                  </div>
                ))}
            </div>

            <div className="flex items-center justify-between bg-mainLight/5 p-4 rounded-2xl border border-mainLight/10">
              <div className="flex flex-col">
                <span className="text-[10px] text-gray-400 font-bold">
                  سعر الوحدة
                </span>
                <span className="text-2xl font-bold text-mainLight">
                  ${Number(product.price).toLocaleString()}
                </span>
              </div>

              <div className="flex items-center bg-white dark:bg-gray-900 rounded-xl p-1 shadow-sm border border-gray-100 dark:border-white/5">
                <button
                  onClick={() => setQuantity((q) => Math.max(1, q - 1))}
                  className="p-2 text-gray-400 hover:text-mainLight transition"
                >
                  <FaMinus size={12} />
                </button>
                <span className="px-4 font-bold text-gray-800 dark:text-white">
                  {quantity}
                </span>
                <button
                  onClick={() => setQuantity((q) => q + 1)}
                  className="p-2 text-gray-400 hover:text-mainLight transition"
                >
                  <FaPlus size={12} />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* قسم الدفع */}
        <div className="p-8 space-y-8">
          <div className="space-y-4">
            <h5 className="flex items-center gap-2 text-lg font-bold text-gray-700 dark:text-gray-200">
              <FaCreditCard className="text-mainLight" /> تفاصيل الدفع والتحويل
            </h5>
          </div>

          {role == "guest" ? (
            <div
              className="py-24 text-center bg-gray-100 dark:bg-white/5 
                rounded-[3rem] border-2 border-dashed 
                border-gray-200 dark:border-white/10"
            >
              <div className="text-6xl mb-6">🔐</div>

              <h3 className="text-xl font-bold text-gray-600 dark:text-gray-300">
                يجب تسجيل الدخول
              </h3>

              <p className="text-sm text-gray-500 mt-2 leading-relaxed">
                يرجى تسجيل الدخول أو إنشاء حساب جديد لتتمكن من إتمام عملية الدفع
                والاطلاع على وسائل الدفع المتاحة.
              </p>

              <Link
                to="/login"
                className="inline-flex items-center justify-center mt-6
               px-6 py-3 rounded-xl font-bold
               bg-mainLight text-white
               hover:bg-mainLight/90
               transition-all shadow-lg
               hover:-translate-y-1 active:scale-95"
              >
                تسجيل الدخول
              </Link>
            </div>
          ) : (
            <>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
                <div className="space-y-2">
                  <select
                    value={selectedBank}
                    onChange={(e) => setSelectedBank(e.target.value)}
                    className="w-full h-14 px-4 rounded-2xl bg-white dark:bg-white/5 border-2 border-gray-100 dark:border-white/10 text-gray-700 dark:text-white font-bold focus:border-mainLight outline-none transition-all cursor-pointer appearance-none"
                  >
                    <option value="" disabled>
                      اختر وسيلة الدفع...
                    </option>
                    {banks?.data?.map((bank) => (
                      <option
                        key={bank.bank_id}
                        value={bank.bank_id}
                        className="text-black"
                      >
                        {bank.name}
                      </option>
                    ))}
                  </select>
                </div>
                <p className="text-[10px] text-gray-400 px-2 font-medium">
                  يرجى تحويل المبلغ الإجمالي إلى الحساب المذكور.
                </p>
              </div>

              {selectedBank && (
                <div className="p-5 rounded-2xl bg-mainLight/5 border border-dashed border-mainLight/30 animate-in fade-in slide-in-from-right-4">
                  <div
                    className="text-xs text-gray-600 dark:text-gray-300 leading-relaxed font-medium"
                    dangerouslySetInnerHTML={{
                      __html: banks?.data
                        .find((item) => item.bank_id == selectedBank)
                        ?.description?.replace(/\n/g, "<br />"),
                    }}
                  />
                </div>
              )}

              <form onSubmit={onSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-2">
                    <label className="text-xs font-bold text-gray-400 mr-2 uppercase">
                      المبلغ المرسل
                    </label>
                    <input
                      type="number"
                      placeholder="0.00"
                      className="w-full h-14 px-6 rounded-2xl bg-white dark:bg-white/5 border border-gray-200 dark:border-white/10 text-gray-800 dark:text-white font-bold focus:ring-2 focus:ring-mainLight/20 focus:border-mainLight outline-none transition-all"
                      onChange={(e) => setAmount(e.target.value)}
                      required
                    />
                  </div>

                  <div className="space-y-2">
                    <label className="text-xs font-bold text-gray-400 mr-2 uppercase">
                      إرفاق صورة الإشعار
                    </label>
                    <div className="relative h-14">
                      <input
                        type="file"
                        accept="image/*"
                        className="absolute inset-0 w-full h-full opacity-0 z-10 cursor-pointer"
                        onChange={(e) => setImage(e.target.files[0])}
                        required
                      />
                      <div className="w-full h-full flex items-center justify-between px-6 rounded-2xl bg-white dark:bg-white/5 border border-dashed border-gray-300 dark:border-white/20 text-gray-400">
                        <span className="text-xs font-bold truncate">
                          {image ? image.name : "اضغط لرفع الصورة..."}
                        </span>
                        <FaRegImage className="text-mainLight" />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col items-center gap-4 pt-4">
                  <div className="text-center">
                    <p className="text-[10px] text-gray-400 font-bold uppercase">
                      الإجمالي المطلوب
                    </p>
                    <p className="text-4xl font-bold text-gray-800 dark:text-white">
                      <span className="text-mainLight">$</span>
                      {(Number(product.price) * quantity).toLocaleString()}
                    </p>
                  </div>

                  <button
                    disabled={IsPending}
                    className="group relative w-full max-w-xs h-14 bg-mainLight text-white font-bold rounded-2xl shadow-lg shadow-mainLight/30 hover:shadow-mainLight/50 hover:-translate-y-1 transition-all active:scale-95 disabled:opacity-50"
                  >
                    {IsPending ? <Spinner sm /> : "تأكيد الحجز الآن"}
                  </button>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
